import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AutoLogoutService } from '@auth/auto-logout-service.service';
import { HttpService } from '@services/http-service';
import { ConfigService } from '@services/webFeeder/config.service';
import { ChartService } from '@services/webFeeder/sckt-chart.service';
import { Constants } from '@utils/constants';
import { NotificationsService } from 'angular2-notifications';
import { Subscription } from 'rxjs';
import { ChartingLibraryWidgetOptions, IChartingLibraryWidget, LanguageCode, ResolutionString, widget } from 'src/assets/charting_library';
import { environment } from 'src/environments/environment';
import { DatafeedService } from './datafeed.service';
import { layoutAdvancedFeaturesToDisabled, layoutBasicFeaturesToDisabled, layoutDefaultFeaturesToDisabled, layoutMobileFeaturesToDisabled } from './trading-view-default-config';

@Component({
  selector: 'trading-view',
  templateUrl: './trading-view.component.html',
  styleUrls: ['./trading-view.component.scss'],
})
export class TradingViewComponent implements OnInit, AfterViewInit, OnDestroy {
  private _symbol: ChartingLibraryWidgetOptions['symbol'] = 'vale3';
  private _theme: any = window.sessionStorage.getItem(Constants.LAYOUT_THEME_DARK) === 'true' ? 'dark' : 'light';;
  private _layout: 'Basic' | "Advanced" | 'MobileEmbed' = 'Advanced';
  private _interval: ChartingLibraryWidgetOptions['interval'] = '15' as ResolutionString;
  private _timeframe: ChartingLibraryWidgetOptions['timeframe'] = '1D';
  // BEWARE: no trailing slash is expected in feed URL
  private _datafeedUrl = 'https://demo_feed.tradingview.com';
  private _libraryPath: ChartingLibraryWidgetOptions['library_path'] = '/assets/charting_library/';
  private _chartsStorageUrl: ChartingLibraryWidgetOptions['charts_storage_url'] = 'https://saveload.tradingview.com';
  private _chartsStorageApiVersion: ChartingLibraryWidgetOptions['charts_storage_api_version'] = '1.1';
  private _clientId: ChartingLibraryWidgetOptions['client_id'] = 'tradingview.com';
  private _userId: ChartingLibraryWidgetOptions['user_id'];
  private _fullscreen: ChartingLibraryWidgetOptions['fullscreen'] = false;
  private _autosize: ChartingLibraryWidgetOptions['autosize'] = true;
  public _containerId: ChartingLibraryWidgetOptions['container'] = 'tv_chart_container';
  private _tvWidget: IChartingLibraryWidget | null = null;
  private subscriptions: Array<Subscription> = [];
  private _colors = {
    upColor: null,
    downColor: null,
    wickUpColor: null,
    wickDownColor: null,
    borderUpColor: null,
    borderDownColor: null,
  };

  private _isMobileWebView: boolean;
  private _customToken: string = null;
  private _chartLastStatus: any;
  private _firstLoad = true;
  private _saveChartUrl: string;
  private _newlyChangedSymbol = false;
  private _usersbrokerName: string = null;
  private _saveChartTimeout: any;
  private _input: any;
  private _onlyOneSymbolChange = true;
  private _validActive = false;
  private firstSymbolChange = false;
  private chartCreated = false;
  private isInWorkspace = true;

  @Output() currentSymbol = new EventEmitter<string>();
  @ViewChild('chartWrapper') chartWrapper: ElementRef<HTMLDivElement>;





  layoutMapFeaturesToDisabled = {
    'Basic': [...layoutBasicFeaturesToDisabled],
    'Advanced': [...layoutAdvancedFeaturesToDisabled],
    'MobileEmbed': [...layoutMobileFeaturesToDisabled]
  }

  @Input()
  set symbol(symbol: ChartingLibraryWidgetOptions['symbol']) {
    if (!symbol) {
      setTimeout(() => {
        this.currentSymbol.emit(this._symbol);
      });
    } else if (this._chartService.getRegisteredSymbols(symbol)) {
      this.notificationService.error('Erro', Constants.WORKSPACE_MSG015);
      setTimeout(() => {
        this._symbol = Constants.BLANK_CHART;
        this.currentSymbol.emit(this._symbol);
      }, 0);
    } else {
      this._symbol = symbol;
      if (!this.firstSymbolChange && this.chartCreated) {
        let newSymbol = symbol;
        if (this._chartService.getRegisteredSymbols(symbol)) {
          newSymbol = Constants.BLANK_CHART;
        }
        this.currentSymbol.next(newSymbol);
        this.loadChart();
      }
    }
  }

  @Input()
  set theme(theme: any) {
    this._theme = theme || this._theme;
  }

  @Input()
  set colors(colors: any) {
    this._colors = colors || this._colors;
  }

  @Input()
  set layout(layout: any) {
    this._layout = layout || this._layout;
  }

  @Input()
  set interval(interval: ChartingLibraryWidgetOptions['interval']) {
    this._interval = interval || this._interval;
  }

  @Input()
  set timeframe(timeframe: ChartingLibraryWidgetOptions['timeframe']) {
    this._timeframe = timeframe || this._timeframe;
  }

  @Input()
  set datafeedUrl(datafeedUrl: string) {
    this._datafeedUrl = datafeedUrl || this._datafeedUrl;
  }

  @Input()
  set libraryPath(libraryPath: ChartingLibraryWidgetOptions['library_path']) {
    this._libraryPath = libraryPath || this._libraryPath;
  }

  @Input()
  set chartsStorageUrl(chartsStorageUrl: ChartingLibraryWidgetOptions['charts_storage_url']) {
    this._chartsStorageUrl = chartsStorageUrl || this._chartsStorageUrl;
  }

  @Input()
  set chartsStorageApiVersion(chartsStorageApiVersion: ChartingLibraryWidgetOptions['charts_storage_api_version']) {
    this._chartsStorageApiVersion = chartsStorageApiVersion || this._chartsStorageApiVersion;
  }

  @Input()
  set clientId(clientId: ChartingLibraryWidgetOptions['client_id']) {
    this._clientId = clientId || this._clientId;
  }

  @Input()
  set userId(userId: ChartingLibraryWidgetOptions['user_id']) {
    this._userId = userId || this._userId;
  }

  @Input()
  set fullscreen(fullscreen: ChartingLibraryWidgetOptions['fullscreen']) {
    this._fullscreen = fullscreen || this._fullscreen;
  }

  @Input()
  set autosize(autosize: ChartingLibraryWidgetOptions['autosize']) {
    this._autosize = autosize || this._autosize;
  }

  @Input()
  set containerId(containerId: ChartingLibraryWidgetOptions['container']) {
    this._containerId = containerId || this._containerId;
  }

  @Input() parentComponent = 'tv-full-heigth';

  featuresDisabledTolayoutMap = {
    Default: [...layoutDefaultFeaturesToDisabled],
    Basic: [...layoutBasicFeaturesToDisabled],
    Advanced: [...layoutAdvancedFeaturesToDisabled],
    MobileEmbed: [...layoutMobileFeaturesToDisabled]
  };



  constructor(private _datafeedSvc: DatafeedService, private configService: ConfigService, private el: ElementRef, private renderer: Renderer2, private _autoLogoutService: AutoLogoutService, private route: ActivatedRoute, private notificationService: NotificationsService, private _chartService: ChartService, private _changeDetectorRef: ChangeDetectorRef, private _httpService: HttpService) {}

  ngOnInit() {
    this.setupUserInfo();
    this.subscribeQueryParams();

    if (!this._userId) {
      const userTemp = this.configService.getUserMarketData();
      this._userId = userTemp ? userTemp.login : this.configService.getHbAccount();
      if (!this._userId || this._userId === 'undefined') {
        const hbaCurrentUser = this.configService.getHbCurrentUser();
        this._userId = hbaCurrentUser ? hbaCurrentUser.username : null;
      }
    }
    this._saveChartUrl = this.configService.getSaveChartUrl();
  }

  async initChart() {
    await this.loadChartSymbolSettings();
    this.createChartWidget(this._chartLastStatus);
  }

  setupUserInfo() {
    if (!this._userId) {
      const userTemp = this.configService.getUserMarketData();
      this._userId = userTemp ? userTemp.login : this.configService.getHbAccount();
      if (!this._userId || this._userId === 'undefined') {
        const hbaCurrentUser = this.configService.getHbCurrentUser();
        this._userId = hbaCurrentUser ? hbaCurrentUser.username : null;
      }
    }
    this._saveChartUrl = this.configService.getSaveChartUrl();
  }

  ngOnDestroy() {
    if (this._tvWidget !== null) {
      this._tvWidget.remove();
      this._tvWidget = null;
    }
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  getComputedVariable(variable) {
    const bodyStyles = window.getComputedStyle(document.body);
    return bodyStyles.getPropertyValue(variable).trim();
  }

  getOverrides(theme) {
    const bodyStyles = window.getComputedStyle(document.body);

    const upColor = this.getComputedVariable(`--color-${String(theme).toLocaleLowerCase()}-candlestick-high`);
    const downColor = this.getComputedVariable(`--color-${String(theme).toLocaleLowerCase()}-candlestick-low`);
    const bgColor = this.getComputedVariable(`--color-${String(theme).toLocaleLowerCase()}-candlestick-bg`);

    const iframe = this.chartWrapper.nativeElement.getElementsByTagName('iframe')[0];
    const iframeDocument = iframe?.contentDocument || iframe?.contentWindow?.document;

    if (iframeDocument) {
      const iframeRoot = iframeDocument.documentElement; // <html> do iframe

      iframeRoot.style.setProperty(`--color-${String(theme).toLocaleLowerCase()}-candlestick-high`, upColor);
      iframeRoot.style.setProperty(`--color-${String(theme).toLocaleLowerCase()}-candlestick-low`, downColor);
      iframeRoot.style.setProperty(`--color-${String(theme).toLocaleLowerCase()}-candlestick-bg`, bgColor);

      iframeRoot.style.setProperty(`--tv-color-pane-background`, bgColor);
      iframeRoot.style.setProperty(`--themed-color-ui-loading-indicator-bg`, bgColor);
      iframeRoot.style.setProperty(`--themed-color-pane-bg`, bgColor);
    }
    // const iframe = this.chartWrapper.nativeElement.getElementsByTagName('iframe')[0];
    // const upColor = bodyStyles.getPropertyValue(`--color-${String(theme).toLocaleLowerCase()}-candlestick-high`).trim();
    // const downColor = bodyStyles.getPropertyValue(`--color-${String(theme).toLocaleLowerCase()}-candlestick-low`).trim();
    // const bgColor = bodyStyles.getPropertyValue(`--color-${String(theme).toLocaleLowerCase()}-candlestick-bg`).trim();

    // document.body.style.setProperty(`--color-${String(theme).toLocaleLowerCase()}-candlestick-bg`, bgColor);
    // document.body.style.setProperty(`--color-${String(theme).toLocaleLowerCase()}-candlestick-bg`, bgColor);
    // document.body.style.setProperty(`--color-${String(theme).toLocaleLowerCase()}-candlestick-bg`, bgColor);

    let studies_overrides: any;
    let overrides: any;
    let chartPropertiesTemp: any;
    let elementSourcesTemp: any;
    let colors = [upColor, downColor, bgColor];
    colors.forEach((hex) => {
      console.log(`%c   ${hex}`, `background: ${hex}; color: ${hex}; padding: 4px 12px; border-radius: 2px;letter-spacing: 4px;`);
    });

    return {
      // 'mainSeriesProperties.candleStyle.upColor': upColor,
      // 'mainSeriesProperties.candleStyle.downColor': downColor,
      // 'mainSeriesProperties.candleStyle.wickUpColor': this.configService.getFavoriteThemeUser() ? '#ffffff' : '#5e5d58',
      // 'mainSeriesProperties.candleStyle.wickDownColor': this.configService.getFavoriteThemeUser() ? '#ffffff' : '#5e5d58',
      // 'mainSeriesProperties.candleStyle.borderUpColor': upColor,
      // 'mainSeriesProperties.candleStyle.borderDownColor': downColor,
      // "paneProperties.separatorColor": "#9598a1",
      'mainSeriesProperties.showCountdown': true,
      'scalesProperties.showStudyLastValue': true,
      'scalesProperties.backgroundColor': bgColor,
      'paneProperties.topMargin': 20,
      'paneProperties.backgroundType': 'solid',
      'paneProperties.background': bgColor,
      'scalesProperties.lineColor': theme == 'dark' ? '#9c9c9c' : '#4a4a4a',
      'scalesProperties.textColor': theme == 'dark' ? '#9c9c9c' : '#4a4a4a',
      'paneProperties.vertGridProperties.color': 'rgba(156, 156, 156, 0.06)',
      'paneProperties.horzGridProperties.color': 'rgba(156, 156, 156, 0.06)'
    } as any;
  }
  _getOverrides(theme) {
    const bodyStyles = window.getComputedStyle(document.body);

    const upColor = bodyStyles.getPropertyValue(`--color-${String(theme).toLocaleLowerCase()}-candlestick-high`).trim();
    const downColor = bodyStyles.getPropertyValue(`--color-${String(theme).toLocaleLowerCase()}-candlestick-low`).trim();
    const bgColor = bodyStyles.getPropertyValue(`--color-${String(theme).toLocaleLowerCase()}-candlestick-bg`).trim();
    let studies_overrides: any;
    let overrides: any;
    let chartPropertiesTemp: any;
    let elementSourcesTemp: any;

    // return {
    //   'mainSeriesProperties.candleStyle.upColor': this._colors.upColor ?? upColor,
    //   'mainSeriesProperties.candleStyle.downColor': this._colors.downColor ?? downColor,
    //   'mainSeriesProperties.candleStyle.wickUpColor': this._colors.wickUpColor ?? (theme == 'dark' ? '#ffffff' : '#5e5d58'),
    //   'mainSeriesProperties.candleStyle.wickDownColor': this._colors.wickDownColor ?? (theme == 'dark' ? '#ffffff' : '#5e5d58'),
    //   'mainSeriesProperties.candleStyle.borderUpColor': this._colors.borderUpColor ?? upColor,
    //   'mainSeriesProperties.candleStyle.borderDownColor': this._colors.borderDownColor ?? downColor,
    //   'paneProperties.background': bgColor,
    //   'mainSeriesProperties.showCountdown': true,
    //   'scalesProperties.showStudyLastValue': true,
    // }

    ///

    if (this._chartLastStatus && this._chartLastStatus.charts) {
      // API CHART
      this._chartLastStatus.charts.forEach((elementCharts) => {
        if (elementCharts.chartProperties) {
          chartPropertiesTemp = {
            'scalesProperties.backgroundColor': elementCharts.chartProperties.scalesProperties ? elementCharts.chartProperties.scalesProperties.backgroundColor : bgColor,
            'scalesProperties.lineColor': elementCharts.chartProperties.scalesProperties ? elementCharts.chartProperties.scalesProperties.lineColor : null,
            'scalesProperties.textColor': elementCharts.chartProperties.scalesProperties ? elementCharts.chartProperties.scalesProperties.textColor : null,
            'paneProperties.background': elementCharts.chartProperties.paneProperties ? elementCharts.chartProperties.paneProperties.background : bgColor,
            'paneProperties.crossHairProperties.color': elementCharts.chartProperties.paneProperties ? elementCharts?.chartProperties?.paneProperties?.crossHairProperties?.color : null,
            'paneProperties.gridProperties.color': elementCharts.chartProperties.paneProperties ? elementCharts?.chartProperties?.paneProperties?.gridProperties?.color : null,
            'paneProperties.horzGridProperties.color': elementCharts.chartProperties.paneProperties ? elementCharts?.chartProperties?.paneProperties?.horzGridProperties?.color : null,
            'paneProperties.vertGridProperties.color': elementCharts.chartProperties.paneProperties ? elementCharts?.chartProperties?.paneProperties?.vertGridProperties?.color : null,
            'paneProperties.scalesProperties.lineColor': elementCharts.chartProperties.scalesProperties ? elementCharts.chartProperties.scalesProperties.lineColor : null,
            'paneProperties.scalesProperties.textColor': elementCharts.chartProperties.scalesProperties ? elementCharts.chartProperties.scalesProperties.textColor : null,
          };
        }
        if (elementCharts.panes) {
          elementCharts.panes.forEach((elementPanes) => {
            if (elementPanes.sources) {
              elementPanes.sources.forEach((elementSources) => {
                if (elementSources.type && elementSources.type.toLowerCase() === 'mainseries') {
                  elementSourcesTemp = {
                    'mainSeriesProperties.candleStyle.upColor': elementSources.state.candleStyle.upColor,
                    'mainSeriesProperties.candleStyle.downColor': elementSources.state.candleStyle.downColor,
                    'mainSeriesProperties.candleStyle.borderColor': elementSources.state.candleStyle.borderColor,
                    'mainSeriesProperties.candleStyle.borderUpColor': elementSources.state.candleStyle.borderUpColor,
                    'mainSeriesProperties.candleStyle.borderDownColor': elementSources.state.candleStyle.borderDownColor,
                    'mainSeriesProperties.candleStyle.wickColor': elementSources.state.candleStyle.wickColor,
                    'mainSeriesProperties.candleStyle.wickUpColor': elementSources.state.candleStyle.wickUpColor,
                    'mainSeriesProperties.candleStyle.wickDownColor': elementSources.state.candleStyle.wickDownColor,
                    'mainSeriesProperties.hollowCandleStyle.upColor': elementSources.state.hollowCandleStyle.upColor,
                    'mainSeriesProperties.hollowCandleStyle.downColor': elementSources.state.hollowCandleStyle.downColor,
                    'mainSeriesProperties.hollowCandleStyle.borderColor': elementSources.state.hollowCandleStyle.borderColor,
                    'mainSeriesProperties.hollowCandleStyle.borderUpColor': elementSources.state.hollowCandleStyle.borderUpColor,
                    'mainSeriesProperties.hollowCandleStyle.borderDownColor': elementSources.state.hollowCandleStyle.borderDownColor,
                    'mainSeriesProperties.hollowCandleStyle.wickColor': elementSources.state.hollowCandleStyle.wickColor,
                    'mainSeriesProperties.hollowCandleStyle.wickUpColor': elementSources.state.hollowCandleStyle.wickUpColor,
                    'mainSeriesProperties.hollowCandleStyle.wickDownColor': elementSources.state.hollowCandleStyle.wickDownColor,
                    'mainSeriesProperties.haStyle.upColor': elementSources.state.haStyle.upColor,
                    'mainSeriesProperties.haStyle.downColor': elementSources.state.haStyle.downColor,
                    'mainSeriesProperties.haStyle.borderColor': elementSources.state.haStyle.borderColor,
                    'mainSeriesProperties.haStyle.borderUpColor': elementSources.state.haStyle.borderUpColor,
                    'mainSeriesProperties.haStyle.borderDownColor': elementSources.state.haStyle.borderDownColor,
                    'mainSeriesProperties.haStyle.wickColor': elementSources.state.haStyle.wickColor,
                    'mainSeriesProperties.haStyle.wickUpColor': elementSources.state.haStyle.wickUpColor,
                    'mainSeriesProperties.haStyle.wickDownColor': elementSources.state.haStyle.wickDownColor,
                    'mainSeriesProperties.barStyle.upColor': elementSources.state.barStyle.upColor,
                    'mainSeriesProperties.barStyle.downColor': elementSources.state.barStyle.downColor,
                    'mainSeriesProperties.hiloStyle.color': elementSources?.state?.hiloStyle.color,
                    'mainSeriesProperties.hiloStyle.borderColor': elementSources.state.hiloStyle.borderColor,
                    'mainSeriesProperties.hiloStyle.labelColor': elementSources.state.hiloStyle.labelColor,
                    'mainSeriesProperties.lineStyle.color': elementSources?.state?.lineStyle.color,
                    'mainSeriesProperties.areaStyle.color1': elementSources?.state?.areaStyle.color1,
                    'mainSeriesProperties.areaStyle.color2': elementSources?.state?.areaStyle.color2,
                    'mainSeriesProperties.areaStyle.linecolor': elementSources.state.areaStyle.linecolor,
                    'mainSeriesProperties.baselineStyle.baselineColor': elementSources.state.baselineStyle.baselineColor,
                    'mainSeriesProperties.baselineStyle.topFillColor1': elementSources.state.baselineStyle.topFillColor1,
                    'mainSeriesProperties.baselineStyle.topFillColor2': elementSources.state.baselineStyle.topFillColor2,
                    'mainSeriesProperties.baselineStyle.bottomFillColor1': elementSources.state.baselineStyle.bottomFillColor1,
                    'mainSeriesProperties.baselineStyle.bottomFillColor2': elementSources.state.baselineStyle.bottomFillColor2,
                    'mainSeriesProperties.baselineStyle.topLineColor': elementSources.state.baselineStyle.topLineColor,
                    'mainSeriesProperties.baselineStyle.bottomLineColor': elementSources.state.baselineStyle.bottomLineColor,
                    'mainSeriesProperties.interval': elementSources.state.interval,
                    'mainSeriesProperties.showCountdown': true,
                    'scalesProperties.showStudyLastValue': true,
                    'paneProperties.topMargin': 20,
                  };
                } else if (elementSources.type && elementSources.type.toLowerCase() === 'study') {
                  studies_overrides = elementSources;
                }
              });
            }
          });
        }
        overrides = Object.assign(chartPropertiesTemp, elementSourcesTemp);
      });
    } else {
      // DEFAULT
      overrides = {
        'mainSeriesProperties.candleStyle.upColor': upColor,
        'mainSeriesProperties.candleStyle.downColor': downColor,
        'mainSeriesProperties.candleStyle.wickUpColor': this.configService.getFavoriteThemeUser() ? '#ffffff' : '#5e5d58',
        'mainSeriesProperties.candleStyle.wickDownColor': this.configService.getFavoriteThemeUser() ? '#ffffff' : '#5e5d58',
        'mainSeriesProperties.candleStyle.borderUpColor': upColor,
        'mainSeriesProperties.candleStyle.borderDownColor': downColor,
        'mainSeriesProperties.showCountdown': true,
        'scalesProperties.showStudyLastValue': true,
        'scalesProperties.backgroundColor': bgColor,
        'paneProperties.topMargin': 20,
        'paneProperties.background': bgColor,
      };
    }
    return overrides;
  }

  getLanguageFromURL(): LanguageCode | null {
    const regex = new RegExp('[\\?&]lang=([^&#]*)');
    const results = regex.exec(location.search);

    return results === null ? null : (decodeURIComponent(results[1].replace(/\+/g, ' ')) as LanguageCode);
  }

  getFeaturesToDisable() {
    let layoutFeatureToDisabled = this.featuresDisabledTolayoutMap[this._layout] ?? [];

    const featuresToDisable:any = [
      ...layoutDefaultFeaturesToDisabled,
      ...layoutFeatureToDisabled
    ];


    return [
      'use_localstorage_for_settings', 'header_saveload', 'header_compare', 'study_templates',
      'symbol_search_hot_key', 'show_interval_dialog_on_key_press', 'timeframes_toolbar',
      ...featuresToDisable
    ] as any;
  }

  getFeaturesToEnable() {
    const featuresToEnable = [];
    return featuresToEnable;
  }

  getTimeFrames() {
    const time_frames: any = [
      { text: '1y', resolution: 'W' },
      { text: '6m', resolution: 'W' },
      { text: '3m', resolution: '60' },
      { text: '1m', resolution: '30' },
      { text: '7D', resolution: '15' },
      { text: '1D', resolution: '5' },
    ];
    return time_frames;
  }

  getInitialTheme() {
    let theme = window.sessionStorage.getItem(Constants.LAYOUT_THEME_DARK) === 'true' ? 'dark' : 'light';
    this._theme = theme;
    if (this._theme == 'System') {
      const darkThemeMq = window.matchMedia('(prefers-color-scheme: dark)');
      if (darkThemeMq.matches) {
        theme = 'dark';
      } else {
        theme = 'light';
      }

      darkThemeMq.addListener((e) => {
        let theme: any = 'light';
        if (e.matches) {
          theme = 'dark';
        } else {
          theme = 'light';
        }

        if (this._tvWidget) {
          this._tvWidget.changeTheme(theme);
          setTimeout(() => {
            let overrides = this.getOverrides(theme);
            this._tvWidget.applyOverrides(overrides);
          }, 0);
        }
      });
    }
    return this._theme;
  }
  private subscriptionQueryParamsChange: Subscription;

  subscribeQueryParams() {
    let customContainerId;

    if (this.subscriptionQueryParamsChange) {
      return;
    }

    this.subscriptionQueryParamsChange = this.route.queryParams.subscribe((params) => {
      if (params['symbol']) {
        this._symbol = params['symbol'].toUpperCase();
        customContainerId = params['chartid'];
        this.currentSymbol.next(this._symbol);
        this._isMobileWebView = params['wv'] === 'true' ? true : false;
        this._userId = params['user'] ? params['user'] : this._userId;
        this._usersbrokerName = params['broker'];
        this.isInWorkspace = false;
      } else {
        const wlConfig = this.configService.getConfigWhitelabel();
        const multibrokerConfig = this.configService.getConfigMultibroker();
        if (wlConfig && wlConfig.system && wlConfig.system.isMultiBroker && multibrokerConfig && multibrokerConfig.usersBrokerName) {
          this._usersbrokerName = multibrokerConfig.usersBrokerName;
        }

        const location = window.location;
        if (location) {
          this.isInWorkspace = !(location.pathname === '/chart' || location.pathname === environment.BASE_HREF + '/chart');
        }
      }
      this._containerId = customContainerId ? this._containerId + customContainerId : this._containerId + String(this._chartService.getNewChartId());

      this.configService.setSymbolInformation({
        chartId: this._containerId,
        symbolName: '',
        symbolInfo: {},
        isInWorkspace: this.isInWorkspace,
        invalidSymbol: false,
      });

      this._changeDetectorRef.detectChanges();
      this.chartCreated = true;
      // if (this._userId && this._userId !== 'undefined') {
      //   this.loadChart();
      // } else {
      //   this.createChartWidget();
      // }
    });
    this.subscriptions.push(this.subscriptionQueryParamsChange);
  }

  ngAfterViewInit(): void {
    this.initChart();
  }

  createChartWidget(initialData?) {
    let theme = this.getInitialTheme();
    let overrides = this.getOverrides(theme);

    let loadingBackgroundColor = this.getComputedVariable(`--color-${String(theme).toLocaleLowerCase()}-candlestick-bg`);

    const widgetOptions: ChartingLibraryWidgetOptions = {
      symbol: this._symbol,
      datafeed: this._datafeedSvc,
      interval: this._interval,
      container: this._containerId,
      library_path: this._libraryPath,
      locale: this.getLanguageFromURL() || 'pt',
      theme,
      ...(initialData && {
        saved_data: initialData,
      }),
      ...(overrides && {
        overrides: overrides,
      }),
      // custom_themes: customTheme.getColors(),
      // disabled_features: ['use_localstorage_for_settings'],
      // enabled_features: ['study_templates'],
      charts_storage_url: this._chartsStorageUrl,
      charts_storage_api_version: this._chartsStorageApiVersion,
      client_id: this._clientId,
      user_id: this._userId,
      fullscreen: this._fullscreen,
      autosize: this._autosize,
      disabled_features: this.getFeaturesToDisable(),
      enabled_features: this.getFeaturesToEnable(),
      timezone: 'America/Sao_Paulo',
      timeframe: this._timeframe,
      time_frames: this.getTimeFrames(),
      auto_save_delay: 1,
      custom_css_url: './../../../../assets/styles/tradingview/styles.css',
      loading_screen: { backgroundColor: loadingBackgroundColor },
      settings_adapter: {
        initialSettings: {
          // symbolWatermark: '{ "visibility": "true", "color": "rgba(244, 67, 54, 0.25)" }',
          // 'trading.Broker': '{"qty": {"AAPL": 10, "NasdaqNM:AAPL": 10}, "orderType": {"NasdaqNM:AAPL": 3}}',
        },
        setValue: function (key, value) {
          console.log(value)
        },
        removeValue: function (key) {
          console.log(`remove value: ${key}`);
        },
      },
    };

    const tvWidget = new widget(widgetOptions);
    this._tvWidget = tvWidget;

    this.applyCustomStyle();
    this._tvWidget.onChartReady(() => {
      const themeCode = widgetOptions.theme === 'dark' ? 1 : 2;
      this.changeChartTheme(themeCode);

      // TODO: Ativado salvar estudos do gráficos
      // this._tvWidget.chart().removeAllStudies();
      const themeChangeSubscription = this.configService.changeThemeDarkLight$.subscribe(this.changeChartTheme.bind(this));
      this.subscriptions.push(themeChangeSubscription);

      if (this._symbol.trim() === Constants.BLANK_CHART.trim()) {
        this._chartService.subscriptionExcpetion();
      }
      const symbolObserver = this._tvWidget.chart().onSymbolChanged();
      symbolObserver.subscribe(
        (obj) => console.log(obj),
        () => {
          let canChange = true;
          if (this._input) {
            canChange = this._input.value.toLowerCase() !== this._symbol.toLowerCase();
          }

          if (canChange) {
            this._tvWidget.chart().setSymbol(this._input.value, () => {});
            this.symbolChange();
          }
        }
      );

      // if(this._chartLastStatus){
      //   this._tvWidget.load(this._chartLastStatus)
      // }
    });

    if (this._userId && this._tvWidget) {
      this._tvWidget.subscribe('onAutoSaveNeeded', () => {
        setTimeout(() => {
          if (this._tvWidget) {
            const symbolInformation = this._tvWidget.chart().symbol().split(':');
            const newSymbol = symbolInformation[symbolInformation.length - 1];
            console.log(symbolInformation);
            if (!symbolInformation) {
              const tempSymbol = this._symbol.trim() === '' ? Constants.BLANK_CHART : this._symbol;
              this.currentSymbol.emit(tempSymbol);
            } else if (newSymbol !== this._symbol) {
              this.currentSymbol.emit(newSymbol);
            }

            if (this._saveChartTimeout) {
              clearTimeout(this._saveChartTimeout);
            }
            this._saveChartTimeout = setTimeout(this.saveChart.bind(this), this._newlyChangedSymbol ? 0 : 1000);
          }
        }, 1000);
      });
    }

    // setTimeout(() => {
    //   const iframe = this.chartWrapper.nativeElement.getElementsByTagName('iframe')[0];
    //   if (iframe) {
    //     this._input = iframe.contentDocument.getElementsByTagName('input')[0];

    //     if (this._input) {
    //       this._input.addEventListener('focus', (event) => {
    //         this._input.value = this._input.value.trim();
    //       });
    //       if (!this._validActive) {
    //         this._input.focus();
    //       }

    //       this._input.addEventListener('change', (event) => {
    //         if (!this.isInWorkspace && this._symbol.trim() === '') {
    //           this._tvWidget.chart().setSymbol(this._input.value, () => { });
    //           this.symbolChange();
    //         }
    //       });
    //     }
    //   }

    // }, 1000);

    // tvWidget.onChartReady(() => {
    //   const themeCode = widgetOptions.theme === 'dark' ? 1 : 2;
    //     this.changeChartTheme(themeCode);
    //     // TODO: Ativado salvar estudos do gráficos
    //     // this._tvWidget.chart().removeAllStudies();
    //     const themeChangeSubscription = this.configService.changeThemeDarkLight$.subscribe(this.changeChartTheme.bind(this));
    //     this.subscriptions.push(themeChangeSubscription);
    //   tvWidget.headerReady().then(() => {
    //     const button = tvWidget.createButton();
    //     button.setAttribute('title', 'Click to show a notification popup');
    //     button.classList.add('apply-common-tooltip');
    //     button.addEventListener('click', () => tvWidget.showNoticeDialog({
    //       title: 'Notification',
    //       body: 'TradingView Charting Library API works correctly',
    //       callback: () => {
    //         console.log('Noticed!');
    //       },
    //     }));
    //     button.innerHTML = 'Check API';
    //   });
    // });
  }

  applyCustomStyle() {
    const iframe = this.chartWrapper.nativeElement.getElementsByTagName('iframe')[0];
    let iframeHtmlElement: any;
    // const cssLink = document.createElement('link');
    // cssLink.href = `${location.origin}/assets/styles/tradingview/styles.css`;
    // cssLink.rel = 'stylesheet';
    // cssLink.type = 'text/css';

    // if (iframe && iframe.contentDocument) {
    //   iframe.contentDocument.head.appendChild(cssLink);
    //   iframeHtmlElement = iframe.contentDocument.documentElement;
    // }

    if (iframeHtmlElement) {
      const bodyStyles = window.getComputedStyle(document.body);
      const primaryColorLight = bodyStyles.getPropertyValue('--color-light-primary').trim();
      const primaryColorDark = bodyStyles.getPropertyValue('--color-dark-primary').trim();

      iframeHtmlElement.style.setProperty('--color-light-primary', primaryColorLight);
      iframeHtmlElement.style.setProperty('--color-dark-primary', primaryColorDark);
    }

    const bodyStyles = window.getComputedStyle(document.body);

    const upColorDark = bodyStyles.getPropertyValue(`--color-dark-candlestick-high`).trim();
    const downColorDark = bodyStyles.getPropertyValue(`--color-dark-candlestick-low`).trim();
    const bgColorDark = bodyStyles.getPropertyValue(`--color-dark-candlestick-bg`).trim();

    const upColorLight = bodyStyles.getPropertyValue(`--color-light-candlestick-high`).trim();
    const downColorLight = bodyStyles.getPropertyValue(`--color-light-candlestick-low`).trim();
    const bgColorLight = bodyStyles.getPropertyValue(`--color-light-candlestick-bg`).trim();

    const iframeDocument = iframe?.contentDocument || iframe?.contentWindow?.document;

    if (iframeDocument) {
      const iframeRoot = iframeDocument.documentElement; // <html> do iframe

      iframeRoot.style.setProperty(`--color-dark-candlestick-high`, upColorDark);
      iframeRoot.style.setProperty(`--color-dark-candlestick-low`, downColorDark);
      iframeRoot.style.setProperty(`--color-dark-candlestick-bg`, bgColorDark);

      iframeRoot.style.setProperty(`--color-light-candlestick-high`, upColorLight);
      iframeRoot.style.setProperty(`--color-light-candlestick-low`, downColorLight);
      iframeRoot.style.setProperty(`--color-light-candlestick-bg`, bgColorLight);
    }
  }

  symbolChange() {
    if (this._onlyOneSymbolChange) {
      this._onlyOneSymbolChange = false;
      const completeSymbol = this._tvWidget.chart().symbol().split(':');
      const newSymbol = completeSymbol[completeSymbol.length - 1];
      if (completeSymbol && completeSymbol.length > 0 && newSymbol !== this._symbol && !this._chartService.getRegisteredSymbols(newSymbol)) {
        const oldSymbol = this._symbol.trim();
        const oldtInterval = this._tvWidget.chart().resolution();
        this.currentSymbol.next(newSymbol);
        this._symbol = newSymbol;
        this._newlyChangedSymbol = true;
        if (this._userId && this._userId !== 'undefined') {
          setTimeout(() => {
            this._chartService.unsubscribeChart(oldSymbol, oldtInterval);
            this.loadChart();
            this._onlyOneSymbolChange = true;
          }, 0);
        } else {
          setTimeout(() => {
            this._chartService.unsubscribeChart(oldSymbol, oldtInterval);
            this.createChartWidget();
            this._onlyOneSymbolChange = true;
          }, 0);
        }
      } else {
        let showError = true;
        const chartInformation = this.configService.getSymbolInformation();
        if (chartInformation && typeof chartInformation === 'string') {
          const chartInfoParsed = JSON.parse(chartInformation);
          if (chartInfoParsed && chartInfoParsed.length > 0) {
            const currentChart = chartInfoParsed.filter((x) => x.chartId === this._containerId)[0];
            if (currentChart && currentChart.invalidSymbol !== undefined && currentChart.symbolInfo !== undefined && currentChart.invalidSymbol !== null && currentChart.symbolInfo !== null) {
              showError = currentChart.invalidSymbol;
              currentChart.invalidSymbol = false;
              currentChart.symbolInfo = currentChart.symbolName ? currentChart.symbolInfo : {};
              this.configService.setSymbolInformation(currentChart);
            }
          }
        }

        this._chartService.subscriptionExcpetion();
        if (showError) {
          this.notificationService.error('Erro', Constants.WORKSPACE_MSG015);
        }
        if (this._userId && this._userId !== 'undefined') {
          setTimeout(() => {
            this.loadChart();
            this._onlyOneSymbolChange = true;
          }, 0);
        } else {
          setTimeout(() => {
            this.createChartWidget();
            this._onlyOneSymbolChange = true;
          }, 0);
        }
      }
    }
  }

  loadChartSymbolSettings() {
    return new Promise((resolve, reject) => {
      const tempSymbol = this._symbol.trim() === '' ? ' ' : this._symbol.toUpperCase().trim();
      let params = `charts?user=${this._userId}&chart=${tempSymbol}`;
      if (!this.configService.getUserMarketData() && this._usersbrokerName) {
        params += `&broker=${this._usersbrokerName}`;
      }
      const isTokenUserMultiBroker = this.configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS && this.configService.getInfoUserLogged() ? true : false;
      if (tempSymbol.trim() !== '') {
        this._httpService.doGet(this._saveChartUrl, params, null, isTokenUserMultiBroker).subscribe(
          (res) => {
            this.firstSymbolChange = true;
            this._newlyChangedSymbol = false;
            if (res.data && res.data.content && typeof res.data.content === 'string') {
              this._chartLastStatus = JSON.parse(res.data.content);
              this._validActive = true;
              if (this._chartLastStatus.charts[0] && this._chartLastStatus.charts[0].panes[0] && this._chartLastStatus.charts[0].panes[0].sources[0] && this._chartLastStatus.charts[0].panes[0].sources[0].state && this._chartLastStatus.charts[0].panes[0].sources[0].state.interval) {
                this._interval = this._chartLastStatus.charts[0].panes[0].sources[0].state.interval;
              } else {
                this._interval = Constants.DEFAULT_INTERVAL as ResolutionString;
              }
            } else {
              this._validActive = false;
              this._chartLastStatus = null;
              this._interval = Constants.DEFAULT_INTERVAL as ResolutionString;
              if (res.error || res._isScalar === false) {
                this.configService.systemNotificationMessage('', Constants.BROKER_MSG014, Constants.ALERT_TYPE.error);
                reject();
                return;
              }
            }
            const chartInformation = this.configService.getSymbolInformation();
            if (chartInformation && typeof chartInformation === 'string') {
              const chartInfoParsed = JSON.parse(chartInformation);
              if (chartInfoParsed && chartInfoParsed.length > 0) {
                const currentChart = chartInfoParsed.filter((x) => x.chartId === this._containerId)[0];
                if (currentChart && currentChart.symbolName !== undefined && currentChart.symbolName !== null) {
                  currentChart.symbolName = tempSymbol.toUpperCase();
                  this.configService.setSymbolInformation(currentChart);
                }
              }
            }
            resolve(true);
          },
          () => {
            this.configService.systemNotificationMessage('', Constants.BROKER_MSG014, Constants.ALERT_TYPE.error);
            reject();
          }
        );
      } else {
        this._validActive = false;
        this._chartLastStatus = null;
        this._symbol = tempSymbol ? tempSymbol : Constants.BLANK_CHART;
        this._interval = Constants.DEFAULT_INTERVAL as ResolutionString;
        this.createChartWidget();
      }
    });
  }

  loadChart() {
    const tempSymbol = this._symbol.trim() === '' ? ' ' : this._symbol.toUpperCase().trim();
    let params = `charts?user=${this._userId}&chart=${tempSymbol}`;
    if (!this.configService.getUserMarketData() && this._usersbrokerName) {
      params += `&broker=${this._usersbrokerName}`;
    }
    const isTokenUserMultiBroker = this.configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS && this.configService.getInfoUserLogged() ? true : false;
    if (tempSymbol.trim() !== '') {
      this._httpService.doGet(this._saveChartUrl, params, null, isTokenUserMultiBroker).subscribe(
        (res) => {
          this.firstSymbolChange = true;
          this._newlyChangedSymbol = false;
          if (res.data && res.data.content && typeof res.data.content === 'string') {
            this._chartLastStatus = JSON.parse(res.data.content);
            this._validActive = true;
            if (this._chartLastStatus.charts[0] && this._chartLastStatus.charts[0].panes[0] && this._chartLastStatus.charts[0].panes[0].sources[0] && this._chartLastStatus.charts[0].panes[0].sources[0].state && this._chartLastStatus.charts[0].panes[0].sources[0].state.interval) {
              this._interval = this._chartLastStatus.charts[0].panes[0].sources[0].state.interval;
            } else {
              this._interval = Constants.DEFAULT_INTERVAL as ResolutionString;
            }
          } else {
            this._validActive = false;
            this._chartLastStatus = null;
            this._interval = Constants.DEFAULT_INTERVAL as ResolutionString;
            if (res.error || res._isScalar === false) {
              this.configService.systemNotificationMessage('', Constants.BROKER_MSG014, Constants.ALERT_TYPE.error);
            }
          }
          const chartInformation = this.configService.getSymbolInformation();
          if (chartInformation && typeof chartInformation === 'string') {
            const chartInfoParsed = JSON.parse(chartInformation);
            if (chartInfoParsed && chartInfoParsed.length > 0) {
              const currentChart = chartInfoParsed.filter((x) => x.chartId === this._containerId)[0];
              if (currentChart && currentChart.symbolName !== undefined && currentChart.symbolName !== null) {
                currentChart.symbolName = tempSymbol.toUpperCase();
                this.configService.setSymbolInformation(currentChart);
              }
            }
          }
          this.createChartWidget();
        },
        () => {
          this.configService.systemNotificationMessage('', Constants.BROKER_MSG014, Constants.ALERT_TYPE.error);
        }
      );
    } else {
      this._validActive = false;
      this._chartLastStatus = null;
      this._symbol = tempSymbol ? tempSymbol : Constants.BLANK_CHART;
      this._interval = Constants.DEFAULT_INTERVAL as ResolutionString;
      this.createChartWidget();
    }
  }

  saveChart() {
    if (this._firstLoad) {
      this._firstLoad = false;
      return;
    }
    if (this._newlyChangedSymbol) {
      return;
    }

    const isTokenUserMultiBroker = this.configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS && this.configService.getInfoUserLogged() ? true : false;
    let params = `charts?user=${this._userId}`;
    if (this._usersbrokerName && !isTokenUserMultiBroker) {
      params += `&broker=${this._usersbrokerName}`;
    }

    if (!this._tvWidget) {
      return;
    }
    this._tvWidget.save((status) => {
      this._httpService.doPost(this._saveChartUrl, params, { symbol: this._symbol.toUpperCase(), content: JSON.stringify(status) }, null, null, isTokenUserMultiBroker).subscribe(
        (res) => {
          if (res.error || res._isScalar === false) {
            this.configService.systemNotificationMessage('', Constants.BROKER_MSG014, Constants.ALERT_TYPE.error);
          }
        },
        () => {
          this.configService.systemNotificationMessage('', Constants.BROKER_MSG014, Constants.ALERT_TYPE.error);
        }
      );
    });
  }

  async changeChartTheme(themeId: number) {
    if (themeId === 0) {
      return;
    }
    // TODO: Desabilitado fundo branco padrão do tema
    // const bodyStyles = window.getComputedStyle(document.body);
    // const bgColor = bodyStyles.getPropertyValue(`--color-${newThemeMode.toLocaleLowerCase()}-candlestick-bg`).trim();
    // const newThemeProperties = {
    //   'paneProperties.background': bgColor,
    //   'scalesProperties.backgroundColor': bgColor
    // };
    // this._tvWidget.applyOverrides(newThemeProperties);
    const newThemeMode = themeId === 1 ? 'dark' : 'light';
    await this._tvWidget.changeTheme(newThemeMode);
    this._tvWidget.load(this._chartLastStatus);
    setTimeout(() => {
      let overrides = this.getOverrides(newThemeMode);
      this._tvWidget.applyOverrides(overrides);
    }, 0);
  }
}
